export default __webpack_public_path__ + "static/media/toggle.b6fd48d7.png";